export default __webpack_public_path__ + "playstore-c.png";